// extracted by mini-css-extract-plugin
export default {"container":"Kv-z","heading":"Lv-z","text":"Mv-z","info":"Nv-z","link":"Ov-z","fullMaxWidth":"Pv-z"};